// Brand assets, constants for the site
export const BRAND_LOGOS = {
  mastersHero: "https://customer-assets.emergentagent.com/job_f72bb9ee-9cca-4462-8827-ad54e6c826ad/artifacts/i5t13yrx_MASTERS%20READY%20LOGO%20MAR16%282%29.jpg",
  mastersRssl: "https://customer-assets.emergentagent.com/job_f72bb9ee-9cca-4462-8827-ad54e6c826ad/artifacts/030vrgtw_MASTERS%20READY%20%20RSSL%20LOGO%281%29.jpg",
  mastersText: "https://customer-assets.emergentagent.com/job_f72bb9ee-9cca-4462-8827-ad54e6c826ad/artifacts/gy6v0gcf_Mastersreadylogo.png",
  bigReadyLeads: "https://customer-assets.emergentagent.com/job_f72bb9ee-9cca-4462-8827-ad54e6c826ad/artifacts/328bore6_BIG%20READY%20LEADS%20LOGO2.png",
  rsslShield: "https://customer-assets.emergentagent.com/job_f72bb9ee-9cca-4462-8827-ad54e6c826ad/artifacts/fj1dfba7_691774589_122123817831200540_5310982950052892923_n.jpg",
};

export const IMAGES = {
  heroBg: "https://static.prod-images.emergentagent.com/jobs/f72bb9ee-9cca-4462-8827-ad54e6c826ad/images/17e484e36a961412440ce33a648e35c40f61d9f2bd2e4917cc447f20dd87306d.png",
  usaMap: "https://static.prod-images.emergentagent.com/jobs/f72bb9ee-9cca-4462-8827-ad54e6c826ad/images/391aa853c2c18755cfbca2beb8063781dfc6311dff6bf85daa48a8a7e170f5a8.png",
  founderAntonio: "https://customer-assets.emergentagent.com/job_masters-hub-3/artifacts/2eovm3jj_Rios%20Face%20pic.png",
  partnerMike: "https://static.prod-images.emergentagent.com/jobs/f72bb9ee-9cca-4462-8827-ad54e6c826ad/images/67d8d320a6993e75cf5132bac046a81452d533092defc7d03bf5fd96b9ebd35c.png",
  partnerMartin: "https://static.prod-images.emergentagent.com/jobs/f72bb9ee-9cca-4462-8827-ad54e6c826ad/images/7690a1104e8f238854ddb3b770aa68b9e2521f3ae52f4f206a9594040090552e.png",
};

export const JOTFORM_URL = "https://form.jotform.com/mastersreadyservices2025/clients-camp-requirements";

export const COMPANY = {
  name: "Master Ready Services, LLC",
  tagline: "More Leads. More Appointments. More Growth.",
  email: "admin@masterreadyservices.pro",
  domain: "Mastersreadyservices.pro",
};

export const SERVICES = [
  { name: "Roofing", icon: "Home" },
  { name: "Solar", icon: "Sun" },
  { name: "Storm Restoration", icon: "CloudLightning" },
  { name: "Hail Damage", icon: "CloudHail" },
  { name: "Wind Damage", icon: "Wind" },
  { name: "PDR", icon: "Car" },
  { name: "Tree Service", icon: "Trees" },
  { name: "Foundation Repair", icon: "Building2" },
  { name: "Window Replacement", icon: "AppWindow" },
  { name: "Exterior Remodeling", icon: "Hammer" },
  { name: "Commercial Prospecting", icon: "Briefcase" },
  { name: "Appointment Setting", icon: "CalendarCheck" },
  { name: "Customer Qualification", icon: "UserCheck" },
  { name: "CRM Support", icon: "Database" },
  { name: "Data Management", icon: "BarChart3" },
  { name: "Market Targeting", icon: "Target" },
];

export const WHY_CHOOSE_US = [
  { num: "01", title: "Flexible Campaign Structures", desc: "Built around your goals — homeowner-only, decision-maker present, retail, commercial, or insurance restoration." },
  { num: "02", title: "Customized Lead Requirements", desc: "We tailor qualification criteria so every lead matches what closes for your business." },
  { num: "03", title: "Qualified Prospect Screening", desc: "Pre-screening that filters time-wasters out and pushes serious prospects forward." },
  { num: "04", title: "Service Area Targeting", desc: "Precision geographic targeting by ZIP, county, or storm zone — no wasted spend." },
  { num: "05", title: "Storm Market Identification", desc: "Real-time storm tracking to identify hail, wind and restoration opportunities first." },
  { num: "06", title: "Appointment Confirmation Support", desc: "Confirmed appointments before they hit your calendar — fewer no-shows, more closes." },
  { num: "07", title: "Organized Lead Delivery", desc: "CRM-ready exports, instant notifications, structured data — no chasing spreadsheets." },
  { num: "08", title: "Scalable Growth Solutions", desc: "From a few quality leads a week to multi-state campaigns — we scale with you." },
];

export const BRANDS = [
  {
    key: "masters",
    name: "Masters Ready Services",
    logo: "mastersHero",
    tagline: "Lead Generation • Appointment Setting • Marketing Solutions",
    manager: "Antonio Murga Rios — Founder",
    description: "Our flagship operation. The primary lead generation and appointment-setting company specializing in contractor and home-service growth.",
    focus: ["Lead Generation", "Appointment Setting", "Marketing Solutions", "CRM Support"],
  },
  {
    key: "bigready",
    name: "Big Ready Leads",
    logo: "bigReadyLeads",
    tagline: "High-Volume Lead Pipelines",
    manager: "Managed by John Alex Moreno",
    description: "Specialized volume-leads division focused on the highest-converting verticals in residential home services.",
    focus: ["Roofing Leads", "Solar Leads", "Storm Restoration", "Home Service Leads"],
  },
  {
    key: "rssl",
    name: "Rock Solid Storm Leads",
    logo: "rsslShield",
    tagline: "Storm. Insurance. Restoration.",
    manager: "Managed by Horacio Eduave Moreno",
    description: "Storm market intelligence division — we hunt hail, wind, and insurance restoration opportunities the moment they happen.",
    focus: ["Storm Damage Leads", "Hail Leads", "Wind Damage Leads", "Insurance Restoration"],
  },
];

export const LEADERSHIP = [
  { name: "Antonio Murga Rios", role: "Owner & Founder", image: "founderAntonio", bio: "Founder of Master Ready Services, LLC. Architect of the parent organization and lead strategist across all three brand divisions." },
  { name: "Mike Juarez", role: "Partner", image: "partnerMike", bio: "Partner driving operational excellence and contractor relationships across the network." },
  { name: "Martin Calvin Cervantes", role: "Partner", image: "partnerMartin", bio: "Partner overseeing market expansion and campaign performance across high-volume verticals." },
];

export const SERVICE_STATES = [
  "Texas", "Florida", "Oklahoma", "Colorado", "Louisiana", "Mississippi", "Alabama", "Georgia",
  "Tennessee", "Arkansas", "Missouri", "Kansas", "Nebraska", "Iowa", "Illinois", "Ohio",
  "North Carolina", "South Carolina", "Kentucky", "Indiana"
];
